import { Component } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { ProfessionalCategory } from '../../common/_types/professional-category';
import { ProfessionalCategoriesService } from '../../common/_services/professional-categories.service';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-professional-category-list',
    templateUrl: './professional-category-list.component.html',
    styleUrls: ['./professional-category-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class ProfessionalCategoryListComponent {
  public professionalCategories: ProfessionalCategory[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  public lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private professionalCategoryService: ProfessionalCategoriesService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loginService: LoginService
  ) {
   
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Categorías Profesionales");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as ProfessionalCategory);
    });
    this.allowWrite = this.loginService.hasPermission("PROFESSIONAL_CATEGORIES.WRITE")
    this.allowDelete = this.loginService.hasPermission("PROFESSIONAL_CATEGORIES.DELETE")
  }

  public async loadData($event: any) {
    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.professionalCategoryService.all(params));
    this.professionalCategories = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(professionalCategory: ProfessionalCategory | null, source?: string) {
    this.router.navigate(['professional-categories/' + (professionalCategory && Object.keys(professionalCategory).length > 0 ? professionalCategory.id : 0) + (source ? '/' + source : '')]);
  }

  delete(professionalCategory: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la categoría profesional?",
        header: "Eliminar categoría profesional",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.professionalCategoryService.delete(professionalCategory.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Categoría profesional eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }
}
